//check to see if user is onboarded

import AppInfoContext from "src/provider/state-manager/appInfoProvider";
import { useContext, useEffect } from "react";
import { CBPOnboarding } from "./cbp-onboarding";
import CBPDashboard from "./cbp-dashboard";
import utility from "src/utils/utility";
import { useGetCbpProfile } from "src/hooks/cbp/useGetCbpProfile";
import VisibilityContext from "src/provider/state-manager/visibilityProvider";

const CBP = () => {
  const {
    info: { institutionData },
  } = useContext(AppInfoContext);

  const { data: cbpProfile } = useGetCbpProfile();

  return (
    <>
      {cbpProfile?.status === "Approved" || cbpProfile?.status === 'AmlScreeningPassed' ? <CBPDashboard /> : <CBPOnboarding />}
    </>
  );
};

export default utility.routeData("cbp", "Cbp", <CBP />);
